<template>
	<div class="grid grid-cols-1 gap-2">
		<div
			v-if="!showPopUp"
			class="flex relative p-5 items-center overflow-hidden lg:max-h-[900px] max-h-[60vh]"
			:class="`bg-black bg-opacity-[2%]`"
		>
			<BigPicture
				:images="images"
				:big-image-index="bigImageIndex"
				:increase-big-image-index="increaseBigImageIndex"
				:decrease-big-image-index="decreaseBigImageIndex"
				:set-show-pop-up="setShowPopUp"
				size="small"
				@big-images-gallery-ref="bigImagesGalleryRef"
			/>

			<ApplicationFlag
				v-for="(flagId, index) in flagIds"
				:key="flagId"
				:data="getFlagData(flagId)"
				:position="getItemPosition(flagId, index)"
				class="max-w-[80%] px-2 z-[1]"
			/>
			<ProductSpecialPriceLabel
				v-if="priceListId && !priceListFlag"
				:price-list-id="priceListId"
				:special-price="specialPrice"
				class="max-w-[80%]"
			/>
		</div>

		<PopUp
			:images="images"
			:big-image-index="bigImageIndex"
			:increase-big-image-index="increaseBigImageIndex"
			:decrease-big-image-index="decreaseBigImageIndex"
			:show-pop-up="showPopUp"
			:set-show-pop-up="setShowPopUp"
			hide-close-icon
		/>

		<ImageList
			:images="images"
			:big-image-index="bigImageIndex"
			:increase-big-image-index="increaseBigImageIndex"
			:decrease-big-image-index="decreaseBigImageIndex"
			:set-big-image-index="setBigImageIndex"
			:show-pop-up="showPopUp"
		/>
	</div>
</template>

<script setup lang="ts">
import type { CategoryFiles } from "@nwt/norce-pwa/dist/runtime/types/api/category/category";
import type { ProductFile } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import type { FilteredProductItemFiles } from "@nwt/norce-pwa/dist/runtime/types/api/searchAndFilter/filters";
import { ref, toRef } from "vue";
import type { SetShowPopUp } from "~/types/storyblok/imageGallery/imageGallery";
import type { SpecialPrice } from "~/types/storyblok/storyblok";

interface Props {
	images: ProductFile[] | CategoryFiles[] | FilteredProductItemFiles[];
	priceListId?: number | null;
	specialPrice?: SpecialPrice;
}
const props = defineProps<Props>();

const images = toRef<
	() => ProductFile[] | CategoryFiles[] | FilteredProductItemFiles[]
>(() => props.images);
// Only the price list flag: the PDP shows no Norce flags.
const { flagIds, priceListFlag, getFlagData, getItemPosition } =
	useProductFlags(() => ({ PriceListId: props.priceListId }), "pdp");
const bigImageIndex = ref<number>(0);
const showPopUp = ref<boolean>(false);
const bigImagesGallery = ref<HTMLElement[]>([]);

const setBigImageIndex = (index: number) => {
	bigImageIndex.value = index;
};

const bigImagesGalleryRef = (ref: { bigImagesGallery: Ref }) => {
	bigImagesGallery.value = ref.bigImagesGallery.value;
};
const increaseBigImageIndex = (value: number) => {
	if (value < images.value.length) {
		bigImageIndex.value = value;
	}
};
const decreaseBigImageIndex = (value: number) => {
	if (value >= 0) {
		bigImageIndex.value = value;
	}
};

const setShowPopUp: SetShowPopUp = (show) => {
	showPopUp.value = show;
};
</script>
